import { Grid } from "@mui/material";
import FormDefinitionField from "./FormDefinitionField.jsx";

export default function FormDefinitionRenderer({ fields }) {
  if (!fields?.length) return null;

  return (
    <Grid container spacing={2}>
      {fields.map((item, index) => (
        <FormDefinitionField key={item.name ?? index} item={item} />
      ))}
    </Grid>
  );
}
